import { render, staticRenderFns } from "./PlayerRegistrationPage.vue?vue&type=template&id=fcf94046&scoped=true&"
import script from "./PlayerRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf94046",
  null
  
)

export default component.exports